var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Account / territory "Unassigned" value. Prefs may persist it as `0` or `"0"`. */
export const UNASSIGNED_SENTINEL = 0;
export function isUnassignedSentinel(id) {
    return Number(id) === UNASSIGNED_SENTINEL;
}
export function unassignedLookupOption() {
    return { value: UNASSIGNED_SENTINEL, label: 'Unassigned', isSentinel: true };
}
export function matchesUnassignedQuery(query) {
    const normalized = query.trim().toLowerCase();
    return normalized.length === 0 || unassignedLookupOption().label.toLowerCase().includes(normalized);
}
export function withoutUnassignedDuplicates(options) {
    const sentinelLabel = unassignedLookupOption().label.toLowerCase();
    return options.filter((option) => {
        if (isUnassignedSentinel(option.value))
            return false;
        return option.label.trim().toLowerCase() !== sentinelLabel;
    });
}
export function withUnassignedFirstPage(result, query, cursor) {
    if (cursor || !matchesUnassignedQuery(query))
        return result;
    const sentinel = unassignedLookupOption();
    return Object.assign(Object.assign({}, result), { options: [sentinel, ...result.options.filter((option) => !isUnassignedSentinel(option.value))] });
}
export function withUnassignedSelected(loadRemote) {
    return (ids) => __awaiter(this, void 0, void 0, function* () {
        const hasUnassigned = ids.some(isUnassignedSentinel);
        const remoteIds = ids.filter((id) => !isUnassignedSentinel(id));
        const remote = loadRemote && remoteIds.length > 0 ? yield loadRemote(remoteIds) : [];
        return hasUnassigned ? [unassignedLookupOption(), ...remote] : remote;
    });
}
